import React from 'react'
import { BarChart, Bar, ResponsiveContainer, Tooltip, Cell, XAxis } from 'recharts'
import { useAppSelector } from 'hooks'
import Close from '@mui/icons-material/Close'
import { generateNationalRankedChartData } from 'utils'
import { Box, Typography } from '@mui/material'
import { COLOR } from 'constant'

export type NationalMetricRankingChartProps = {
  metricName: string
  countryName: string
  onClose?: () => void
  color?: string
}

export default function NationalMetricRankingChart({
  metricName,
  countryName,
  onClose,
  color,
}: NationalMetricRankingChartProps) {
  const { yearFilter } = useAppSelector(({ vibrancy }) => vibrancy.configuration)
  const countryData = useAppSelector(({ vibrancy }) => vibrancy.countryData)
  const metricGroups = useAppSelector(({ vibrancy }) => vibrancy.metricGroup)

  const data = generateNationalRankedChartData(metricGroups, countryData, {
    globalYear: yearFilter.currentYear,
    metricName: metricName,
  })
  const CustomTooltip: React.FC<any> = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const dataTooltip = payload[0].payload
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
            padding: '6px 12px',
            border: `1px solid ${COLOR.NAVY}`,
            borderRadius: '12px',
            cursor: 'pointer',
          }}
        >
          <span style={{ fontWeight: 400 }}>{dataTooltip?.countryName}</span>
          <span>Score: {dataTooltip?.score.toFixed(2)}</span>
        </Box>
      )
    }

    return null
  }
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
        <Close
          style={{
            width: '34px',
            height: '34px',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '8px',
            // background: COLOR.LIGHT,
            position: 'absolute',
            right: '0px',
            background: '#f5f4f5',
          }}
          onClick={() => onClose && onClose()}
        />
      </Box>
      <Box style={{ marginBottom: '40px', marginRight: '70px' }}>
        <Typography variant='h5' sx={{ typography: { sm: 'h6', xs: 'body1' } }}>
          Global Ranking: {metricName}, {yearFilter.currentYear}
        </Typography>

        <Typography gutterBottom>
          Rank: {data.find((el) => el.countryName === countryName)?.cRank} of {data?.length} countries
        </Typography>
      </Box>
      <ResponsiveContainer width='100%' height='75%'>
        <BarChart data={data}>
          <XAxis dataKey='countryName' tick={false} tickLine={false} axisLine={false} type='category' />
          <Tooltip cursor={{ fill: 'rgba(0, 0, 0, 0.07)' }} content={<CustomTooltip />} />
          <Bar dataKey='score'>
            {data.map((entry, index) => (
              <Cell
                cursor='pointer'
                fill={entry.countryName === countryName ? color : '#c0c0c0'}
                key={`cell-${index}`}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </>
  )
}
